import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  title: 'API Urls',
  attributeName: 'app',
  fields: [
    {
      attributeName: 'clientAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Client API Url',
      helpText:"The last number is the minbuildNumber to be used and then we can add quryparams such as deviceId,oculusUser,myZip,myCountryCode",
    },
    {
      attributeName: 'spacesAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Spaces API Url',
      helpText: '',
    },
  ],
};